/**
 * App Component
 * Root application component.
 */

import { Toaster } from 'react-hot-toast';
import { AppRouter } from '@router/AppRouter';
import { ToastContainer } from '@components/feedback';
import { ErrorBoundary } from '@components/common';

/**
 * Main application component.
 * Sets up routing, error boundaries, and global components.
 */
export const App = () => {
  return (
    <ErrorBoundary>
      <AppRouter />
      {/* Legacy toast system (Zustand-based) */}
      <ToastContainer />
      {/* New toast system (react-hot-toast) */}
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#fff',
            color: '#1f2937',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            borderRadius: '8px',
            padding: '12px 16px',
          },
          success: {
            iconTheme: {
              primary: '#10B981',
              secondary: '#fff',
            },
          },
          error: {
            iconTheme: {
              primary: '#EF4444',
              secondary: '#fff',
            },
          },
        }}
      />
    </ErrorBoundary>
  );
};
